import React from 'react';
import { FormControl, Grid, InputLabel, Select } from '@material-ui/core';
import { Field } from 'formik';

export const StripEquipmentSelector = props => {
  const {
    fieldTypeName,
    fieldClassificationName,
    vehicleTypeList = [],
    vehicleClassificationList = [],
    disabled,
    onSelectType,
    onSelectClassification,
    selectedType,
    selectedCategory,
  } = props;

  const handleChangeEquipmentType = selectedEquipmentTypeId => {
    const selType = vehicleTypeList.find(tipo => tipo.cdTipoVeiculo === selectedEquipmentTypeId);
    onSelectType(selType);
  };

  const handleChangeEquipmentClassification = selectedClassificationId => {
    const selClassif = vehicleClassificationList.find(
      classificacao => classificacao.cdClassificacaoVeiculo === selectedClassificationId
    );
    onSelectClassification(selClassif);
  };

  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <FormControl variant="filled" margin="dense" fullWidth disabled={disabled}>
            <InputLabel htmlFor="tipoVeiculo" shrink={true}>
              Tipo de veículo*
            </InputLabel>
            <Field
              name={fieldTypeName}
              id="tipoVeiculo"
              native
              as={Select}
              value={selectedType?.cdTipoVeiculo}
              onChange={e => handleChangeEquipmentType(parseInt(e.target.value))}
            >
              {vehicleTypeList ? (
                vehicleTypeList.map((type, idx) => (
                  <option key={`${idx}-${type.cdTipoVeiculo}`} value={type.cdTipoVeiculo}>
                    {type.deTipoVeiculo}
                  </option>
                ))
              ) : (
                <option>Nenhuma linha registrada</option>
              )}
            </Field>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl variant="filled" margin="dense" fullWidth disabled={disabled}>
            <InputLabel htmlFor="tipoCategoria" shrink={true}>
              Categoria*
            </InputLabel>
            <Field
              name={fieldClassificationName}
              id="tipoCategoria"
              native
              as={Select}
              value={selectedCategory?.cdClassificacaoVeiculo}
              onChange={e => handleChangeEquipmentClassification(parseInt(e.target.value))}
            >
              {vehicleClassificationList ? (
                vehicleClassificationList.map((classif, idx) => (
                  <option
                    key={`${idx}-${classif.cdClassificacaoVeiculo}`}
                    value={classif.cdClassificacaoVeiculo}
                  >
                    {`${classif.sgSlassificacaoVeiculo} - ${classif.deClassificacaoVeiculo}`}
                  </option>
                ))
              ) : (
                <option>Nenhuma linha registrada</option>
              )}
            </Field>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};
